export default {
  components: {},
  filters: {},
  data() {
    return {}
  },
  computed: {
    /*************** 是否有會員等級 ***************/
    isHasLevel() {
      if (this.memberLevelDiscount === 0) {
        return false
      }
      if (typeof this.memberLevelDiscount === 'object' && parseInt(this.memberLevelDiscount.discount) === 0) {
        return false
      }
      if (Array.isArray(this.memberLevelDiscount) && !this.memberLevelDiscount.length) {
        return false
      }
      return this.memberInfo?.level && !!this.memberLevelDiscount
    },
  },
  watch: {},
  created() {},
  methods: {
    /**
     * @description 給定服務與已經取得的discountParams給這個fun，會得到價錢
     * service: 服務
     */
    composeTotal(service, discountInParams) {
      if (Array.isArray(service) && service.length) {
        const prices = []
        if (service[0].levelDiscountValue > 0) {
          service.forEach((item) => {
            const num = item.price * item.qty - item.levelDiscountValue
            prices.push(num)
          })
          return prices
        }

        let discount = discountInParams || this.memberLevelDiscount

        service.forEach((item) => {
          if (typeof discount === 'number') {
            const num = (item?.price - Math.round(item?.price * (discount / 100))) * item?.qty
            prices.push(num)
          } else if (typeof discount === 'object') {
            let num = 0
            
            if (Array.isArray(discount) && discount.length) {
              const currentDiscount = discount.find(target => target.id === item.priceId)
              num = currentDiscount.discountType === '%' ? item.price * item.qty * (1 - parseInt(currentDiscount.discount) / 100) : (item.price - parseInt(currentDiscount.discount)) * item.qty
            } else {
              num = this.composeTotalForDiscountObj({ price: item.price, discountType: discount?.discountType, discount: discount?.discount })
            }

            prices.push(num)
          } else if (typeof discount === 'undefined') {
            const num = (item?.price - Math.round(item?.price * (0 / 100))) * item?.qty
            prices.push(num)
          }
        })

        return prices
      }
      // 如果是修改，就會有，service.levelDiscountValue。那就直接return 回已經儲存的資料
      if (service.levelDiscountValue > 0) {
        return service.price * service.qty - service.levelDiscountValue
      }
      let discount = discountInParams || this.memberLevelDiscount

      if (!service?.price) {
        return 0
      }
      if (typeof discount === 'number') {
        return (service?.price - Math.round(service?.price * (discount / 100))) * service?.qty
      } else if (typeof discount === 'object') {
        return this.composeTotalForDiscountObj({ price: service.price, discountType: discount.discountType, discount: discount.discount })
      } else if (typeof discount === 'undefined') {
        // 這邊是為了「現在沒有會員等級折扣」的時候，所以有可能undefined
        return (service?.price - Math.round(service?.price * (0 / 100))) * service?.qty
      }
    },

    /**
     * @description 給定price and discount and type，傳出折扣過後的價錢
     */
    composeTotalForDiscountObj({ price, discountType, discount }) {
      if (!discountType && !discount ) {
        return price
      }
      const result = discountType === '%' ? price - Math.round(price * (discount / 100)) : price - discount
      return result < 0 ? 0 : result
    },
    composeMemberLevelDiscount(service) {
      const map = () => {
        return {
          reservation: this.memberInfo?.level?.servicePrices,
          prepaid: this.memberInfo?.level?.prepaids,
          deposit: this.memberInfo?.level?.deposits,
        }
      }
      // 如果不是儲值金計畫，走這邊
      const mapType = map()[this.orderType]
      // 如果:prepaid-plan(購買包月form、包月detail)
      if (map()[this.orderType] && service && service?.type === 'prepaid-plan') {
        const serviceIndex = mapType.findIndex((item) => item.id === service.priceId)
        return serviceIndex > -1 ? map()[this.orderType][serviceIndex] : 0
      }
      // 如果是儲值金走這邊(deposit-form，)
      if (map()[this.orderType] && service && service?.type === 'deposit-plan') {
        const serviceIndex = mapType.findIndex((item) => item.id === service.id)
        return serviceIndex > -1 ? map()[this.orderType][serviceIndex] : 0
      }
      // type: cosmetic
      if (map()[this.orderType] && service && (service?.type === 'cosmetic' || service[0]?.type === 'cosmetic')) {
        if (Array.isArray(service) && service.length) {
          return mapType.filter((item) => service.some((singleService) => parseInt(singleService.priceId) === item.id))
        } else {
          const serviceIndex = mapType.findIndex((item) => item.id === parseInt(service.priceId))
          return serviceIndex > -1 ? map()[this.orderType][serviceIndex] : 0
        }
      }
      return map()[this.orderType] ?? 0
    },
    updateSubmitData(nvl) {
      this.$emit('updateSubmitData', nvl)
    },
    continueChangeTab(nvl) {
      this.$emit('continueChangeTab', nvl)
    },
    /**
     * @description 一般的id格式
     */
    idFormat(type) {
      return {
        id: '',
        discount: 0,
        discountType: 'fixed',
        type,
      }
    },
    groupAlias(type) {
      return {
        groupAlias: '',
        id: '',
        discount: 0,
        discountType: 'fixed',
        type,
      }
    },
    /**
     * @description 給定服務列表與會員的折扣種類
     * @param {Array}} serviceList
     * @param {Array} memberLevelDiscount
     */
    setServicesMemberLevelPrice(serviceList, memberLevelDiscountType, key = 'id') {
      try {
        serviceList.forEach((serviceItem) => {
          memberLevelDiscountType.forEach((servicePriceItem) => {
            if (parseInt(serviceItem[key]) === parseInt(servicePriceItem.id)) {
              // 先取得discount 折扣
              serviceItem['discount'] = parseInt(servicePriceItem['discount'])
              serviceItem['discountType'] = servicePriceItem['discountType']
              // 計算出折扣價錢（levelPrice：一般美容折扣價錢）
              serviceItem['levelPrice'] =
                servicePriceItem['discountType'] === '%'
                  ? parseInt(serviceItem.price - Math.round(serviceItem.price * (parseInt(servicePriceItem.discount) / 100)))
                  : parseInt(serviceItem.price - Math.round(parseInt(servicePriceItem.discount) * 1))
              serviceItem['levelPrice'] = serviceItem['levelPrice'] < 0 ? 0 : serviceItem['levelPrice']

              // 計算出折扣價錢（levelPrice：指定美容師折扣價錢）
              serviceItem['scheduleItemLevelPrice'] =
                servicePriceItem['discountType'] === '%'
                  ? parseInt(serviceItem.scheduleItemPrice - Math.round(serviceItem.scheduleItemPrice * (parseInt(servicePriceItem.discount) / 100)))
                  : parseInt(serviceItem.scheduleItemPrice - Math.round(parseInt(servicePriceItem.discount) * 1))
              serviceItem['scheduleItemLevelPrice'] = serviceItem['scheduleItemLevelPrice'] < 0 ? 0 : serviceItem['scheduleItemLevelPrice']
            }
          })
        })
        return serviceList
      } catch (error) {
        console.error(error.message)
      }
    },
  },
}
